import { StateProvider, StateParams } from "@uirouter/angularjs";
import { ServerUtility } from "../records/server/serverUtility";

//import { vsName as ContractMachineDetailComponent } from "./views/info/component";
//import { vsName as ContractMachineDetailComponent } from "./views/infoNew/component";
import { IRowCommandEventArgs } from "../records/grids/controller";
import { vsComponentName as contractPatchBulkComponentName } from "./views/patchBulk";
import { vsComponentName as contractPatchResultComponentName } from "./views/patchBulk/patchBulkResults";
import { vsComponentName as bulkLogComponentName } from "./views/bulkLog";
import { vsComponentName as bulkLogResultComponentName } from "./views/bulkLog/patchBulkResults";
import { vsComponentName as contractInstanceComponentName } from "./views/Instances";

export function routeConfig($stateProvider: StateProvider) {
  $stateProvider
    .state("main.contract", {
      url: "contract",
      component: contractInstanceComponentName,
    })
    // .state("main.contract.type", {
    //   abstract: true,
    //   url: "/{contractType}",
    //   resolve: {
    //     contractType: [
    //       "$stateParams",
    //       ContractServiceName,
    //       ($stateParams: StateParams, contractService: ContractService) =>
    //         contractService.getContractType($stateParams.contractType),
    //     ],
    //   },
    // })
    // .state("main.contract.type.grid", {

    // })
    // .state("main.contract.type.add", {
    //   url: "/add",
    //   component: ContractEditComponentName,
    // })
    // .state("main.contract.Edit", {
    //   url: "/edit/{contractId:int}",
    //   component: ContractEditComponentName,
    //   resolve: {
    //     contract: [
    //       ServerUtilityName,
    //       "$stateParams",
    //       function (serverUtility: ServerUtility, $stateParams: StateParams) {
    //         const contractId = $stateParams["contractId"];
    //         return serverUtility
    //           .sendApiRequest({
    //             method: "get",
    //             url: `api/contract/contract/${contractId}`,
    //           })
    //           .then((r) => <ServiceResponse<unknown>>r);
    //       },
    //     ],
    //   },
    // })
    // .state("main.contract.info", {
    //   url: "/{contractId:int}/info",
    //   component: ContractMachineDetailComponent,
    //   resolve: {
    //     contractId: [
    //       "$stateParams",
    //       function ($stateParams: StateParams) {
    //         return $stateParams["contractId"];
    //       },
    //     ],
    //     contract: [
    //       ServerUtilityName,
    //       "contractId",
    //       function (serverUtility: ServerUtility, contractId: number) {
    //         return serverUtility
    //           .sendApiRequest({
    //             method: "get",
    //             url: `api/contract/contract/${contractId}`,
    //           })
    //           .then((r) => <ServiceResponse<unknown>>r);
    //       },
    //     ],
    //     contractMachines: [
    //       ServerUtilityName,
    //       "contractId",
    //       function (serverUtility: ServerUtility, contractId: number) {
    //         return serverUtility
    //           .sendApiRequest({
    //             method: "get",
    //             url: `api/contract/contractMachines/${contractId}`,
    //           })
    //           .then((r) => (<ServiceResponse<unknown>>r).Results);
    //       },
    //     ],
    //   },
    // })
    // .state("main.contract.info", {
    //   url: "/{contractId:int}/info",
    //   component: ContractMachineDetailComponent,
    //   params: {
    //     type: undefined,
    //   },
    //   resolve: {
    //     contract: [ContractService],
    //   },
    // })
    .state("main.contract.Patch", {
      url: "/bulkUpdate",
      component: contractPatchBulkComponentName,
      params: {
        contractIds: [],
      },
      resolve: {
        contractIds: [
          "$stateParams",
          ($stateParams: StateParams) =>
            $stateParams.contractIds.length === 0
              ? [0]
              : $stateParams.contractIds,
        ],
      },
    })
    .state("main.contract.Patch.result", {
      url: "/result",
      params: {
        bulkUpdateResponse: undefined,
      },
      component: contractPatchResultComponentName,
      resolve: {
        bulkUpdateResponse: [
          "$stateParams",
          ($stateParams: StateParams) => $stateParams.bulkUpdateResponse,
        ],
      },
    })
    // .state("main.contract.masteragreement", {
    //   url: "/masteragreement",
    //   template: "<ui-view></ui-view>",
    //   abstract: true,
    // })
    // .state("main.contract.masteragreement.grid", {
    //   url: "/grid",
    //   component: contractMasterAgreementGridComponentName,
    //   resolve: {},
    // })
    // .state("main.contract.masteragreement.info", {
    //   url: "/{contractId:int}/info",
    //   component: contractMasterDetailComponentName,
    //   resolve: {
    //     contractId: [
    //       "$stateParams",
    //       function ($stateParams: StateParams) {
    //         return $stateParams["contractId"];
    //       },
    //     ],
    //     contractInstance: [
    //       ServerUtilityName,
    //       "contractId",
    //       function (serverUtility: ServerUtility, contractId: number) {
    //         return serverUtility
    //           .sendApiRequest({
    //             method: "get",
    //             url: `api/contract/contractMasterAgreement?id=${contractId}`,
    //           })
    //           .then((r) => (<ServiceResponse<unknown>>r).Results);
    //       },
    //     ],
    //   },
    // })
    // .state("main.contract.instances.info", {
    //   url: "/{instanceId:int}/info",
    //   component: contractInstanceDetailComponentName,
    //   resolve: {
    //     instanceId: [
    //       "$stateParams",
    //       function ($stateParams: StateParams) {
    //         return $stateParams["instanceId"];
    //       },
    //     ],
    //     contractInstance: [
    //       ServerUtilityName,
    //       "instanceId",
    //       function (serverUtility: ServerUtility, instanceId: number) {
    //         return serverUtility
    //           .sendApiRequest({
    //             method: "get",
    //             url: `api/contract/contractInstance?id=${instanceId}`,
    //           })
    //           .then((r) => (<ServiceResponse<unknown>>r).Results);
    //       },
    //     ],
    //   },
    // })
    .state("main.contract.bulklog", {
      url: "/bulklog",
      component: bulkLogComponentName,
      resolve: {},
    })
    .state("main.contract.bulklog.results", {
      url: "/{logId:int}/results",
      component: bulkLogResultComponentName,
      resolve: {},
    });
}
routeConfig.$inject = ["$stateProvider"];

function lockContract(
  serverUtility: ServerUtility,
  args: IRowCommandEventArgs<any>
) {
  serverUtility
    .sendApiRequest({
      method: "PATCH",
      url: `/api/contract/contract/lock`,
      data: { Id: args.data.Id, Locked: !args.data.Locked },
    })
    .then((response) => {
      if (response) {
        args.data.Locked = !args.data.Locked;
      }
    });
}
